export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'star-scandal',
    name: '明星黑料',
    description: '最劲爆的明星丑闻与黑历史，深度扒皮不为人知的娱乐圈阴暗面',
    icon: 'ri-spy-line',
    color: 'primary',
  },
  {
    id: 'cat-2',
    slug: 'romance-exposure',
    name: '恋情曝光',
    description: '明星恋爱、分手、出轨、复合，娱乐圈情感大戏第一手报道',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
  },
  {
    id: 'cat-3',
    slug: 'variety-insider',
    name: '综艺内幕',
    description: '综艺节目幕后真相揭露，剧本安排、剪辑黑幕、艺人真实关系',
    icon: 'ri-tv-2-line',
    color: 'secondary',
  },
  {
    id: 'cat-4',
    slug: 'film-behind',
    name: '影视幕后',
    description: '影视剧拍摄内幕、演员不和、导演争议、票房造假等独家揭秘',
    icon: 'ri-film-line',
    color: 'primary',
  },
  {
    id: 'cat-5',
    slug: 'fashion-flop',
    name: '时尚翻车',
    description: '明星红毯造型翻车、品牌代言风波、时尚圈内的审美灾难现场',
    icon: 'ri-t-shirt-line',
    color: 'accent',
  },
  {
    id: 'cat-6',
    slug: 'legal-trouble',
    name: '法律纠纷',
    description: '明星涉法涉诉案件追踪，偷税漏税、合同纠纷、名誉侵权等法律事件',
    icon: 'ri-scales-line',
    color: 'secondary',
  },
];